import { TableCell, TableCellProps } from "@mui/material"
import React, { ReactNode } from "react"
import styled from "styled-components"
import { theme } from "../../../../theme"

export type TBodyCellProps = {
  align?: TableCellProps["align"]
  className?: string
  colSpan?: number
  children?: ReactNode
  dataCy?: string
  onClick?: (e?: any) => any
}

export const TBodyCell = (props: TBodyCellProps) => {
  const { align, className, colSpan, onClick = () => null, dataCy, children } = props

  return (
    <CustomCell className={className} align={align} onClick={onClick} colSpan={colSpan} data-cy={dataCy}>
      {children}
    </CustomCell>
  )
}

const CustomCell = styled(TableCell)`
  font-size: ${theme.fontSize.m};
  border: none;

  &:not(:first-child) {
    padding-left: 0;
  }

  &:first-child {
    padding-left: ${theme.spacing.lx};
  }
`
